import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../stateManagement/hooks/redux";
import { useDispatch } from "react-redux";
import { applyRoadCategoryFilters, setCategoryGroups, setRoadCategoryFilterIsOpened } from "../../../../../stateManagement/reducers/objectTypes/RoadCategorySegmentsSlice";
import { Checkbox, FormControlLabel } from "@mui/material";
import { getItemWebStorage, setItemWebStorage } from "../../../../../features/webStorageSaver";
import { roadCategorySegmentsApiSlice } from "../../../../../api/rtk/base/slices/roadCategorySegmentsApiSlice";
import { showToastMessage } from "../../../../../stateManagement/reducers";

const filtersIcon = require('../../../../../assets/images/icons/filters-icon.svg').default
const closeIcon = require('../../../../../assets/images/fontAwesomeIcons/xmark-solid-dark.svg').default

export const roadCategoryFiltersOptions: any = {
    IA: {
        name: 'IA',
        color: '#8B00FF',
        categoryId: 1
    },
    IБ: {
        name: 'IБ',
        color: '#7CFC00',
        categoryId: 2
    },
    IВ: {
        name: 'IВ',
        color: '#FC89AC',
        categoryId: 100000
    },
    II: {
        name: 'II',
        color: '#008000',
        categoryId: 3
    },
    III: {
        name: 'III',
        color: '#30D5C8',
        categoryId: 4
    },
    IV: {
        name: 'IV',
        color: '#d53032',
        categoryId: 5
    },
    V: {
        name: 'V',
        color: '#FFA500',
        categoryId: 6
    },
    others: {
        name: 'Другие',
        color: '#660066',
        categoryId: 999999
    },
}

const optionsRoadCategoryInitialState = {
    IA: false,
    IБ: false,
    IВ: false,
    II: false,
    III: false,
    IV: false,
    V: false,
    others: false
}

export default function RoadCategorySegmentsOverlay() {
    const dispatch = useDispatch()

    const [isSmallForRoadCategorySegmentFilter, setIsSmallForRoadCategorySegmentFilter] = useState(false);
    const [optionsRoadCategoryState, setRoadCategoryState] = useState(getItemWebStorage("roadCategoryMapFilters") ?? optionsRoadCategoryInitialState);

    const isOpenedRoadCategoryFilter = useAppSelector(state => state.roadCategorySegments.roadCategoryFilterIsOpened)

    function onCheckRoadCategoryFilters(fieldName: string, event: any) {
        setItemWebStorage('roadCategoryMapFilters', { ...getItemWebStorage("roadCategoryMapFilters"), [fieldName]: event.target.checked })
        dispatch(applyRoadCategoryFilters({ ...getItemWebStorage("roadCategoryMapFilters"), [fieldName]: event.target.checked }))
        setRoadCategoryState((prevState: any) => ({ ...prevState, [fieldName]: event.target.checked }));
    }

    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallForRoadCategorySegmentFilter(contentHeaderWidth < 767);
    }, [sideBarState])

    const {
        data: categoryGroups,
        isFetching: fetchingCategoryGroups,
        isError: isErrorCategoryGroups
    } = roadCategorySegmentsApiSlice.useFetchCategoryGroupsDictQuery({})

    useEffect(() => {
        if (categoryGroups) {
            dispatch(setCategoryGroups(categoryGroups?.value))
        }
    }, [categoryGroups])

    useEffect(() => {
        if (isErrorCategoryGroups) {
            dispatch(showToastMessage({ messageText: 'Ошибка загрузки протяженности категорийных участков', messageType: "error", windowType: "map" }))
        }
    }, [isErrorCategoryGroups])

    return (
        <>
            {((isSmallForRoadCategorySegmentFilter && isOpenedRoadCategoryFilter) || !isSmallForRoadCategorySegmentFilter) &&
                <div className="map-overlay-road-category-segments map-overlay">
                    {isSmallForRoadCategorySegmentFilter &&
                        <div className="close-filter-window-button" onClick={() => dispatch(setRoadCategoryFilterIsOpened(!isOpenedRoadCategoryFilter))}>
                            <span>Закрыть</span>
                            <img src={closeIcon} />
                        </div>
                    }
                    <div className="road-category-segments-filters-div">
                        <div className="road-category-segments-checkbox-div">
                            {Object.keys(roadCategoryFiltersOptions).map((key => {
                                return (
                                    <div>
                                        <FormControlLabel
                                            className="check-string"
                                            key={`${key}RoadCategorySegment`}
                                            checked={optionsRoadCategoryState[key]}
                                            name={`${key}`}
                                            onChange={(event: any) => onCheckRoadCategoryFilters(`${key}`, event)}
                                            color={roadCategoryFiltersOptions[key].color}
                                            control={<Checkbox className="ch-white" style={{ color: roadCategoryFiltersOptions[key].color }} />}
                                            label={roadCategoryFiltersOptions[key].name}
                                        />
                                    </div>
                                )
                            }))}
                        </div>
                        <div className="road-category-segments-length-div">
                            {Object.keys(roadCategoryFiltersOptions).map((categoryGroup: any) => {
                                let length = categoryGroups && categoryGroups.value.find((categoryGroupItem: any) => categoryGroupItem.CategoryId === roadCategoryFiltersOptions[categoryGroup].categoryId)?.Length;
                                return <span id={`${categoryGroup}`}>{length ? `${length} км` : '—'}</span>
                            })}
                        </div>
                    </div>
                </div>
            }
            {(isSmallForRoadCategorySegmentFilter && !isOpenedRoadCategoryFilter) &&
                <div className="roadCategoryFilterTurnButton" onClick={() => dispatch(setRoadCategoryFilterIsOpened(!isOpenedRoadCategoryFilter))}>
                    <img src={filtersIcon} />
                    <span>Фильтры</span>
                </div>
            }
        </>
    )
}
